module.exports = __webpack_public_path__ + "static/media/SarahSwitek_04_BodySensations_36.44957f08.mp3";